import moment from "moment";
import { qs } from "url-parse";

export default (state, action) => {
  return {
    filters: filters(state.filters, action),
    meta: meta(state.meta, action),
    history: history(state.history, action)
  };
};

function filters(state, action) {
  if (action.type == "SET_SEARCH") {
    return Object.assign({}, state, action.search);
  }
  return state;
}

function meta(state, action) {
  if (action.type == "SET_LOADING") {
    const update = { loading: action.loading };
    if (!action.loading) {
      update.isFirstLoading = false;
    }
    return Object.assign({}, state, update);
  }
  if (action.type == "SET_PAGE") {
    return Object.assign({}, state, { page: action.page });
  }
  if (action.type == "SET_HAS_MORE") {
    return Object.assign({}, state, { hasMore: action.hasMore });
  }
  if (action.type == "INC_PAGE") {
    return Object.assign({}, state, { page: state.page + 1 });
  }
  if (action.type == "SET_SEARCH") {
    return Object.assign({}, state, {
      hasMore: true,
      page: 1,
      isFirstLoading: true
    });
  }
  return state;
}

function history(state, action) {
  if (action.type == "SET_LOG") {
    return action.data;
  }
  if (action.type == "APPEND_LOG") {
    return {
      items: state.items.concat(action.data.items),
      campaigns: Object.assign({}, state.campaigns, action.data.campaigns),
      categories: Object.assign({}, state.categories, action.data.categories),
      item_cnt: action.data.item_cnt
    };
  }
  return state;
}

function getFilters(search) {
  const initial = {
    date_from: moment().format("YYYY-MM-DD"),
    date_to: moment().format("YYYY-MM-DD"),
    sort_by: "datetime",
    sort_order: "desc"
  };

  const parsedSearch = qs.parse(search);

  return Object.assign(initial, parsedSearch);
}

export function getInitialState(search) {
  return {
    filters: getFilters(search),
    meta: {
      isFirstLoading: true,
      loading: false,
      hasMore: true,
      page: 1
    },
    history: {
      items: [],
      campaigns: {},
      categories: {},
      item_cnt: 0
    }
  };
}
